// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.select-parent-box[data-v-282c5920]{\n  position: relative;\n  left: -50px;\n}\n.enter-class-close[data-v-282c5920] {\n  pointer-events: none;\n  color:gray !important;\n}\n", ""]);
// Exports
module.exports = exports;
